import { useEffect, useRef } from 'react';

type ScrollHandler = () => void;

const scrollHandlers = new Map<string, ScrollHandler>();
const TAB_SCROLL_RETRY_DELAYS_MS = [0, 80, 180];

export function scrollTabToTop(tabName: string) {
  const runHandler = () => {
    const handler = scrollHandlers.get(tabName);

    if (!handler) {
      return false;
    }

    handler();
    return true;
  };

  if (runHandler()) {
    return;
  }

  TAB_SCROLL_RETRY_DELAYS_MS.forEach((delay) => {
    setTimeout(runHandler, delay);
  });
}

export function useRegisterTabScrollHandler(
  tabName: string,
  handler: ScrollHandler,
) {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const registeredHandler = () => {
      handlerRef.current();
    };

    scrollHandlers.set(tabName, registeredHandler);

    return () => {
      if (scrollHandlers.get(tabName) === registeredHandler) {
        scrollHandlers.delete(tabName);
      }
    };
  }, [tabName]);
}
